import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import { Toaster } from "sonner";
import useSWR from "swr";
import { LandingPage } from "@/components/LandingPage";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const fetcher = async (url) => {
  const response = await axios.get(url);
  return response.data;
};

const Home = () => {
  const { data: content, error, isLoading } = useSWR(`${API}/landing-content`, fetcher);

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FAFAF9] font-body text-[#252E2B]" data-testid="landing-loading-state">
        Preparing Aisha’s page...
      </div>
    );
  }

  if (error || !content) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-[#FAFAF9] p-6 text-center font-body text-[#252E2B]" data-testid="landing-error-state">
        We couldn’t load the page content. Please try again shortly.
      </div>
    );
  }

  return (
    <div data-testid="aisha-landing-app">
      <LandingPage content={content} />
      <Toaster richColors position="bottom-right" />
    </div>
  );
};

function App() {
  return (
    <div className="App" data-testid="app-root">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
